export default function bounce (opts) {
  opts.el = document.getElementById(opts.el) || undefined
  opts.borderEl = document.getElementById(opts.borderEl) || undefined
  opts.speed = opts.speed || 1
  opts.rate = opts.rate || 20
  opts.offsetRight = opts.offsetRight || 0
  opts.offsetBottom = opts.offsetBottom || 0

  var top = 0
  var left = 0
  var btm = 0
  var right = 0

  function setBounds () {
    if (opts.borderEl === undefined) {
      opts.el.style.position = 'fixed'
      btm = window.innerHeight
      right = window.outerWidth
    } else {
      opts.el.style.position = 'absolute'
      btm = opts.borderEl.getBoundingClientRect().height
      right = opts.borderEl.getBoundingClientRect().width
    }
  }

  var w = opts.el.getBoundingClientRect().width + opts.offsetRight
  var h = opts.el.getBoundingClientRect().height + opts.offsetBottom
  var l = Math.floor(Math.random() * (right - w))
  var t = Math.floor(Math.random() * (btm - h))

  var bounceItem = {
    el: opts.el,
    l: l,
    t: t,
    r: l + w,
    b: t + h,
    vx: Math.ceil(Math.random() * opts.speed) + 1, // x velocity
    vy: Math.ceil(Math.random() * opts.speed) + 1 // y velocity
  }

  // move
  function move () {
    // if past or passing bounds and moving further out of bounds, bounce item back
    if ((bounceItem.t + bounceItem.vy < top && bounceItem.vy < 0) || (bounceItem.b + bounceItem.vy > btm && bounceItem.vy > 0)) bounceItem.vy = -bounceItem.vy
    if ((bounceItem.l + bounceItem.vx < left && bounceItem.vx < 0) || (bounceItem.r + bounceItem.vx > right && bounceItem.vx > 0)) bounceItem.vx = -bounceItem.vx

    // change position by velocity in item object and in dom
    bounceItem.l += bounceItem.vx; bounceItem.r += bounceItem.vx
    bounceItem.t += bounceItem.vy; bounceItem.b += bounceItem.vy
    bounceItem.el.style.left = bounceItem.l + 'px'
    bounceItem.el.style.top = bounceItem.t + 'px'
  }

  var bounceInterval = null

  if (opts.el !== undefined) {
    // update bounds when window resized or scrolled
    window.addEventListener('resize', function () {
      setBounds()
    })

    // initial bounds setup
    setBounds()
  }

  function start () {
    bounceInterval = window.setInterval(move, opts.rate)
  }

  function stop () {
    clearInterval(bounceInterval)
  }

  return {
    start,
    stop
  }
}
